'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowDownLeftAndArrowUpRight, iconArrowDownLeftAndArrowUpRightTag } from '@ni/nimble-components/dist/esm/icons/arrow-down-left-and-arrow-up-right';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowDownLeftAndArrowUpRight };
export { iconArrowDownLeftAndArrowUpRightTag };
export const NimbleIconArrowDownLeftAndArrowUpRight = wrap(IconArrowDownLeftAndArrowUpRight);